import {
  initialState,
  Actions,
  State,
  NEW_FILE,
  NEW_FILE_SUCCESS,
  NEW_FILE_ERROR,
  RESET_NEW_FILE,
} from "../../types/files/new";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_FILE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_FILE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_FILE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_FILE:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
